/* eslint-disable no-unused-vars */
import React from "react";
import "./Location.module.css";
import edgeLogo from "../../images/on-going-projects/the-edge/gallery/edge-logo.png";

function Location() {
  return (
    <div className="location-container" id="location">
      <h1>
        Location
      </h1>
      <div className="google-maps-iframe-container">

        <div className="logo-container">
          <img alt="The Edge Logo" src={edgeLogo} className="asset-1" />
          <span className="address-text">
            Old Door No.30, Door No. 14, New, Padmavathy Thayar Street, Gopalapuram, Chennai, <br /> Tamil Nadu 600086, India
          </span>
        </div>
        <iframe
          title="google map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15547.09812563869!2d80.2578659896089!3d13.0500187685929!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526777017c9701%3A0x39f0c7473f9b635b!2sThe%20Edge%20-%20Baashyaam%20Constructions!5e0!3m2!1sen!2sin!4v1769248163258!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default Location;
